import AmpersandState from 'ampersand-state';

const Module = AmpersandState.extend({
    idAttribute: 'companyId',

    props: {
        companyId: 'string',
        gDrive: 'object',
        gCalendar: 'object',
        github: 'object',
        gitlab: 'object' // for future
    },

    parse(obj) {

        return obj;
    }
});

module.exports = Module;